// extracted by mini-css-extract-plugin
export default {"container":"qp-z","ratingLayout":"rp-z","ratingLabel":"sp-z","nonInteractiveRatingLabel":"tp-z"};